import React, {useMemo} from 'react';
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import type {HotspotExplorerProps, HotspotExplorerSortMode} from "../types";
import {
    buildCountryPath,
    buildHotspotDetailPath,
    getHotspotExplorerStats,
    getVisibleHotspots,
    sortHotspots
} from "../helpers";
import {HotspotExplorerShell} from "../hotspot-explorer-shell";

export function AllHotspotsView({hotspotExplorerIndex}: HotspotExplorerProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const sortMode = (searchParams.get('sort') as HotspotExplorerSortMode) || 'visits';
    const hotspots = hotspotExplorerIndex.hotspots;
    const visibleHotspots = useMemo(() => sortHotspots(getVisibleHotspots(hotspots, {}), sortMode), [hotspots, sortMode]);
    const countryGroups = hotspotExplorerIndex.countryGroups;

    const setSortMode = (nextSortMode: HotspotExplorerSortMode) => {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.set('sort', nextSortMode);
        setSearchParams(nextParams, {replace: true});
    }

    const openCountry = (countryCode: string) => {
        navigate(`${buildCountryPath(countryCode)}${location.search}`);
    }

    const openHotspot = (locationId: string) => {
        navigate(buildHotspotDetailPath(locationId), {
            state: {returnTo: `${location.pathname}${location.search}`}
        });
    }

    return (
        <HotspotExplorerShell
            eyebrow="Hotspot Explorer"
            title="All Hotspots"
            intro="Browse the hotspots you have visited, grouped by country and ranked by the filters on the right."
            stats={getHotspotExplorerStats(visibleHotspots, 'Countries')}
            panelHeading="By Country"
            groups={countryGroups}
            onSelectGroup={openCountry}
            hotspots={visibleHotspots}
            sortMode={sortMode}
            onChangeSort={setSortMode}
            onOpenHotspot={openHotspot}
        />
    );
}
